import type { UIMessage } from "ai";

import {
  getClientAdvisorModelOption,
  type ClientAdvisorModelOptionId,
} from "@fitness-app/data-models/entities/ClientAdvisorConfig";
import type { TFunction } from "i18next";

// TRE-1606/1607 — client advisor chat shared constants (client-web API + mobile UI).

// Model options are canonical in data-models (one table for the agent, the chat route,
// the admin picker and this UI layer); re-exported to keep existing import paths.
export {
  clientAdvisorModelOptions,
  defaultClientAdvisorModelOptionId,
  getClientAdvisorModelOption,
  isClientAdvisorModelOptionId,
  type ClientAdvisorModelOptionId,
} from "@fitness-app/data-models/entities/ClientAdvisorConfig";

export const clientAdvisorChatType = "client_advisor";
export const advisorSessionsQueryKey = ["clientAdvisorChatSessions"];

export const clientAdvisorSuggestions = [
  "uiCommon:what-am-i-training-today",
  "uiCommon:i-don-t-have-time-to-train-today",
  "uiCommon:i-want-to-swap-a-meal",
  "uiCommon:what-happens-after-the-programme",
];

export const createClientAdvisorSessionMetadata = (modelId: ClientAdvisorModelOptionId) => {
  const modelOption = getClientAdvisorModelOption(modelId);

  return {
    model: {
      provider: modelOption.provider,
      optionId: modelOption.id,
      name: modelOption.model,
      label: modelOption.label,
      reasoningEffort: modelOption.reasoningEffort,
    },
  };
};

export const createAdvisorSessionTitle = (tUi: TFunction, text: string) => {
  const firstLine = text.replace(/\s+/g, " ").trim();
  return firstLine.length > 56
    ? `${firstLine.slice(0, 56)}...`
    : firstLine || tUi<string>("uiCommunication:new-conversation");
};

export const emptyAdvisorChatMessageParts: UIMessage["parts"] = [];
